import { Application } from "@hotwired/stimulus"
import GuideController from "../controllers/guide_controller"
import WaterfallController from "../controllers/waterfall_controller"
import GuideCardsController from "../controllers/guide_cards_controller"
import GuideNavigationController from "../controllers/guide_navigation_controller"

// Cards load asynchronously; restore only once their layout is ready.
history.scrollRestoration = "manual"

const application = Application.start()
application.register("guide", GuideController)
application.register("waterfall", WaterfallController)
application.register("guide-cards", GuideCardsController)
application.register("guide-navigation", GuideNavigationController)
